
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Vaccine = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M23.2,6.6l1-1.1L19.5.8l-1.1,1,1.9,1.9L18.4,5.5,15.6,2.7,6.2,12.2a4.9,4.9,0,0,0-.6,6.2L2.7,21.3l1,1,2.9-2.9a4.6,4.6,0,0,0,2.7.9,4.9,4.9,0,0,0,3.5-1.5l9.5-9.4L19.5,6.6l1.8-1.9ZM11.8,17.8a3.9,3.9,0,0,1-2.5,1,3.1,3.1,0,0,1-2.2-.9,3.4,3.4,0,0,1,.1-4.7l2.1-2L15.6,14Zm4.9-5-6.3-2.7,5.2-5.3,4.6,4.6Z"></path>
        </g>
      </g>
    </IconBase>);
};

Vaccine.defaultProps = {
  title: 'Vaccine',
};

export default Vaccine;
